import _ from 'lodash';
import { createAxios } from '../../lib/axiosFactory';
import { errorParser } from '../../lib/response/errorParser';
import {
  CampaignSummary,
  SubscribersSummary,
  CampaignStats,
  Summary
} from '../../lib/interfaces/dashboardSummary';

export const state = function (): Summary {
  return {
    campaign: {
      mostRecentSentCampaign: undefined,
      nextScheduledCampaign: undefined,
      campaignStatistics: {
        draftCampaignsCount: 0,
        scheduledCampaignsCount: 0,
        sentCampaignsCount: 0
      }
    },
    subscribers: {
      subscribersCount: 0,
      recentlyAddedUsersCountExcludingTextToJoin: 0,
      unsubscribersCount: 0,
      activeKeyWordsCount: 0,
      newSubscribersTextToJoinCount: 0
    }
  };
};

export const getters = {
  getCampaignSummary(state: Summary): CampaignSummary {
    return state.campaign;
  },

  getSubscribersSummary(state: Summary): SubscribersSummary {
    return state.subscribers;
  },

  getSubscribersCount(state: Summary): SubscribersSummary['subscribersCount'] {
    return state.subscribers.subscribersCount;
  },

  getTextToJoinCount(
    state: Summary
  ): SubscribersSummary['activeKeyWordsCount'] {
    return state.subscribers.activeKeyWordsCount;
  },

  getCampaignStatistics(state: Summary): CampaignStats {
    return state.campaign.campaignStatistics;
  }
};

export const mutations = {
  setCampaign(state: Summary, campaign: CampaignSummary): void {
    state.campaign = campaign;
  },
  setSubscribers(state: Summary, subscribers: SubscribersSummary): void {
    state.subscribers = subscribers;
  }
};

export const actions = {
  async loadSummary(
    context: any,
    payload?: any
  ): Promise<{
    success: boolean;
    errors: Record<string, any>;
    body: Record<string, any>;
  }> {
    try {
      const response = await createAxios().get(
        'backend/account-summaries-show'
      );

      const summary = response.data.data.attributes;

      context.commit('setCampaign', summary.campaigns);
      context.commit('setSubscribers', summary.subscribers);
      return { success: true, errors: {}, body: response.data };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  }
};
